import {OperatingSystem} from '../../../enums';
import {FileUploadRes} from '@yasc/yasc-material-components';

export class ProductDetailRes {
    id!: number;
    name!: string;
    productImage?: FileUploadRes;
}

export class ProductArtifactReq {
    productId!: string;
    operatingSystem!: OperatingSystem;
    version!: string;
}
